module.exports = __webpack_public_path__ + "img/f_ic_accept.2064ba65.svg";